module.exports = __webpack_public_path__ + "static/img/icon1.09bc957b.png";